export default __webpack_public_path__ + "static/media/epmIcon.7e81ca31.png";